export const dropdownValuesConstants = {
	DROPDOWN_VALUES_GET_PDF_TEMPLATES_REQUEST:
		"DROPDOWN_VALUES_GET_PDF_TEMPLATES_REQUEST",
	DROPDOWN_VALUES_GET_PDF_TEMPLATES_SUCCESS:
		"DROPDOWN_VALUES_GET_PDF_TEMPLATES_SUCCESS",
	DROPDOWN_VALUES_GET_PDF_TEMPLATES_ERROR:
		"DROPDOWN_VALUES_GET_PDF_TEMPLATES_ERROR",

	DROPDOWN_VALUES_GET_MERCHANT_STATUS_REQUEST:
		"DROPDOWN_VALUES_GET_MERCHANT_STATUS_REQUEST",
	DROPDOWN_VALUES_GET_MERCHANT_STATUS_SUCCESS:
		"DROPDOWN_VALUES_GET_MERCHANT_STATUS_SUCCESS",
	DROPDOWN_VALUES_GET_MERCHANT_STATUS_ERROR:
		"DROPDOWN_VALUES_GET_MERCHANT_STATUS_ERROR",

	DROPDOWN_VALUES_GET_COMPANY_USERS_REQUEST:
		"DROPDOWN_VALUES_GET_COMPANY_USERS_REQUEST",
	DROPDOWN_VALUES_GET_COMPANY_USERS_SUCCESS:
		"DROPDOWN_VALUES_GET_COMPANY_USERS_SUCCESS",
	DROPDOWN_VALUES_GET_COMPANY_USERS_ERROR:
		"DROPDOWN_VALUES_GET_COMPANY_USERS_ERROR",

	DROPDOWN_VALUES_GET_COMPANIES_REQUEST:
		"DROPDOWN_VALUES_GET_COMPANIES_REQUEST",
	DROPDOWN_VALUES_GET_COMPANIES_SUCCESS:
		"DROPDOWN_VALUES_GET_COMPANIES_SUCCESS",
	DROPDOWN_VALUES_GET_COMPANIES_ERROR: "DROPDOWN_VALUES_GET_COMPANIES_ERROR",

	DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_REQUEST:
		"DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_REQUEST",
	DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_SUCCESS:
		"DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_SUCCESS",
	DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_ERROR:
		"DROPDOWN_VALUES_GET_HEADQUARTERS_MERCHANTS_ERROR",

	DROPDOWN_VALUES_GET_TERMINALS_REQUEST:
		"DROPDOWN_VALUES_GET_TERMINALS_REQUEST",
	DROPDOWN_VALUES_GET_TERMINALS_SUCCESS:
		"DROPDOWN_VALUES_GET_TERMINALS_SUCCESS",
	DROPDOWN_VALUES_GET_TERMINALS_ERROR: "DROPDOWN_VALUES_GET_TERMINALS_ERROR",

	DROPDOWN_MERCHANT_TIME_ZONE_REQUEST: "DROPDOWN_MERCHANT_TIME_ZONE_REQUEST",
	DROPDOWN_MERCHANT_TIME_ZONE_SUCCESS: "DROPDOWN_MERCHANT_TIME_ZONE_SUCCESS",
	DROPDOWN_MERCHANT_TIME_ZONE_ERROR: "DROPDOWN_MERCHANT_TIME_ZONE_ERROR",
};
